import React from "react";
import { cn } from "../../lib/cn";

/**
 * Standard full-page shell for marketing routes. Defaults to the light canvas;
 * pass className to tweak spacing or layers (legacy shells merged via `cn`).
 */
export function PageShell({ children, className }) {
  return (
    <section
      className={cn(
        "min-h-screen w-full bg-white text-slate-700",
        className
      )}
    >
      {children}
    </section>
  );
}
